// extracted by mini-css-extract-plugin
export default {"wrapper":"W_CapsulesEmptyState_wrapper__Qst3v","image":"W_CapsulesEmptyState_image__hlbPV","text":"W_CapsulesEmptyState_text__OvSec"};